module.exports = __webpack_public_path__ + "img/Youtube.88ffd347.svg";